export default __webpack_public_path__ + "static/media/avatar_lion2.50a1af7f.mp3";